module.exports = __webpack_public_path__ + "img/societybg.80c7ee30.png";